<template>
  <div class="hero-section">
    <div class="hero-container">
      <div class="hero-content">
        <h1 class="hero-title">
          用智能安全，<br>
          <span class="highlight">守护</span>数字未来
        </h1>
        <p class="hero-description">
          北京至讯信息技术有限公司致力于为企业提供基于腾讯安全产品与AI智能体平台的融合解决方案，涵盖智能威胁防护、数据安全治理、AI智能体定制开发、业务自动化与智能化升级等一站式服务，助力企业在安全可控的环境中实现业务创新与可持续增长。
        </p>
        <div class="hero-actions">
          <button class="btn btn-primary" @click="$emit('open-modal')">了解解决方案</button>
          <button class="btn btn-outline" @click="$emit('open-modal')">咨询数字化顾问</button>
        </div>
      </div>
      <div class="hero-image-wrapper">
        <img src="../assets/hero-bg.png" alt="Digital Technology Illustration" class="hero-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSection',
}
</script>

<style scoped>
.hero-section {
  width: 100%;
  padding: 60px 40px;
  position: relative;
  overflow: hidden;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
}

.hero-container {
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  width: 100%;
  height: 100%;
}

.hero-content {
  flex: 1;
  max-width: 600px;
  z-index: 2;
  position: relative;
  animation: fadeInUp 0.8s ease-out both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-title {
  font-size: clamp(28px, 4vw, 56px);
  line-height: 1.4;
  color: #1a1a1a;
  font-weight: 800;
  margin-bottom: 24px;
  letter-spacing: 2px;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.9), 0 0 40px rgba(255, 255, 255, 0.8);
}

.hero-title .highlight {
  color: #0052d9;
  background: linear-gradient(90deg, #0052d9, #266eff, #00d2ff, #0052d9);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shimmer 4s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.hero-description {
  font-size: clamp(14px, 1.5vw, 18px);
  line-height: 1.8;
  color: #222;
  margin-bottom: 48px;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.9), 0 0 20px rgba(255, 255, 255, 0.8);
  font-weight: 600;
}

.hero-actions {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.btn {
  padding: 14px 32px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
  border: none;
  outline: none;
}

.btn-primary {
  background-color: #0052d9;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 82, 217, 0.2);
}

.btn-primary:hover {
  background-color: #0040b3;
  box-shadow: 0 6px 16px rgba(0, 82, 217, 0.3);
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  color: #0052d9;
  border: 1px solid #0052d9;
}

.btn-outline:hover {
  background-color: rgba(0, 82, 217, 0.05);
  transform: translateY(-2px);
}

.hero-image-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;
  overflow: hidden;
}

.hero-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: left center;
}

@media (max-width: 1200px) {
  .hero-section {
    padding: 40px 24px;
  }
  .hero-content {
    max-width: 520px;
  }
}

@media (max-width: 900px) {
  .hero-section {
    min-height: auto;
    padding: 40px 20px 60px;
  }
  .hero-container {
    flex-direction: column;
    gap: 0;
  }
  .hero-content {
    max-width: 100%;
    text-align: center;
  }
  .hero-actions {
    justify-content: center;
  }
  .hero-description {
    margin-bottom: 32px;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding: 32px 16px 48px;
  }
  .hero-title {
    margin-bottom: 16px;
  }
  .hero-description {
    margin-bottom: 24px;
  }
  .btn {
    padding: 12px 24px;
    font-size: 14px;
    width: 100%;
    text-align: center;
  }
  .hero-actions {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
